import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DiagnosisModel } from 'app/EMR/DoctorModels/diagnosis.model';
import { EMRService } from 'app/EMR/EMR.service';
import { SurgeryCategoryModel } from 'app/EMR/HistoryModels/surgery_Category.model';
import { ExportService } from 'app/reports/services/export.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-diadnosissearch',
  templateUrl: './diadnosissearch.component.html',
  styleUrls: ['./diadnosissearch.component.scss']
})
export class DiadnosissearchComponent implements OnInit {

  destroydisearch$: Subject<boolean> = new Subject<boolean>();
  private diagnosisdata: any = [];
  private diagonisisName: string = '';
  private diagonisCode: string = '';
  private diagonisicatid: number = 0;
  private daigonisCategory: any
  private diagnosis_ds: MatTableDataSource<DiagnosisModel>
  destroydiagsea$: Subject<boolean> = new Subject<boolean>();
  private startdate: any;
  private enddate: any;
  private maxDate: any;
  private serachlistarray: any = {};
  private daigonisCategory_dslist = new MatTableDataSource<SurgeryCategoryModel>();
  private displayedColumns_departments: string[] = ['categoryName', 'department', 'icdCode', 'isActive'];
  constructor(private emrservice: EMRService, private exportdata: ExportService,
    private dashboardService: DashboardService,
    private authService: AuthService, private dialogRef: MatDialogRef<DiadnosissearchComponent>, @Optional() @Inject(MAT_DIALOG_DATA) private data: any,) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.startdate = this.authService.getServerDate;
    this.enddate = this.authService.getServerDate;
    this.serachlistarray = {};
    this.maxDate = moment(this.authService.getServerDate).format('YYYY-MM-DD');
    this.getDiagonisisCategory(0);
    this.GetGetDiagnosis(0, 0, 0);
  }
  closedialog() {
    this.dialogRef.close(0);
  }
  ngOnDestroy() {
    this.destroydiagsea$.next(true);
    this.destroydiagsea$.unsubscribe();
    this.startdate = null;
    this.enddate = null;
    this.serachlistarray = null;
    this.maxDate = null;
    this.daigonisCategory_dslist = null;
    this.displayedColumns_departments = null;
    this.daigonisCategory = null;
    this.diagnosisarray = null;
  }

  GetGetDiagnosis(diagonisiid, searchname, searchtype) {
   
    this.emrservice.GetGetDiagnosismaster(diagonisiid,searchname,searchtype).pipe(takeUntil(this.destroydisearch$)).subscribe(data => this.sucees_dagonisdata(data), err => this.err_daigonsis(err));
  }
  diagnosisarray: any;
  sucees_dagonisdata(data) {
    this.diagnosisarray = [];
    this.diagnosisarray = data;
    if (data.length > 0) {
      this.daigonisCategory_dslist.data = data;
    }

  }
  err_daigonsis(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  getDiagonisisCategory(diaid) {
    this.emrservice.GetDiagonisCategory(diaid).pipe(takeUntil(this.destroydiagsea$)).subscribe(data => {
      this.daigonisCategory = data;
    })
  }

  // applyFilter_grid(filterValue) {
  //  debugger
  //   const finddata = this.filerdata(this.diagnosisarray, filterValue);
  //   console.log(this.diagnosisarray,'called pk_DiagnosisId')
  //   if (finddata.length > 0) {
  //     this.daigonisCategory_dslist.data = finddata;
  //     // this.diagnosisarray = finddata;

  //   } else {
  //     // this.daigonisCategory_dslist.data=[];
  //     this.diagnosisarray = finddata;
  //     if (filterValue.length >= 3) {
  //       if (filterValue != null && filterValue != '') {
  //         var pdata = filterValue;
  //       } else {
  //         pdata = 0;
  //       }
  //        this.GetGetDiagnosis(0,pdata,'A');
  //     }
  //   }
  //   this.daigonisCategory_dslist.filter = filterValue.trim().toLowerCase();
  //   this.GetGetDiagnosis(0,0,'A');
  // }

applyFilter_grid(filterValue: string) {
  const trimmedFilter = filterValue.trim();

  if (trimmedFilter === '') {
    this.GetGetDiagnosis(0, 0, 0);
  } else {
    if(trimmedFilter.length >= 3){
      this.GetGetDiagnosis(0, trimmedFilter, 'A');
    }
  }
}


  // filerdata(items: any[], searchText: string) {
  //   console.log(items);
  //   return items ? items.filter(item => {
  //     console.log(item);
  //     return item && item.diagnosisName && item.diagnosisName.search(new RegExp(searchText, 'i')) > -1;
  //   }) : [];
  // }

  getNameById(id) {
    const item = this.daigonisCategory.filter(data => data.pk_DiagnosisCatId === id);
    return item ? item[0]?.categoryName : '';
  }

  selectRow(row) {
    this.dialogRef.close(row);
    // this.data.disableaddmaster
  }

  exportexcel(): void {
    this.exportdata.open_loader_Dialogtwo();
    let element = document.getElementById('content');
    this.exportdata.Newexportxcel(element, 'Diagnosis Master List');

  }
}

